import { createFileRoute } from "@tanstack/react-router"
import LtiDynamicRegistrationPage from "@/routes/-pages/LtiDynamicRegistration"

export interface LtiDynamicRegistrationSearchParams {
  openid_configuration?: string
  registration_token?: string
}

export const Route = createFileRoute("/lti/dynamic-registration")({
  validateSearch: (search: Record<string, unknown>): LtiDynamicRegistrationSearchParams => ({
    openid_configuration: typeof search.openid_configuration === "string" ? search.openid_configuration : undefined,
    registration_token: typeof search.registration_token === "string" ? search.registration_token : undefined,
  }),
  component: DynamicRegistrationRoute,
})

function DynamicRegistrationRoute() {
  const { openid_configuration, registration_token } = Route.useSearch()

  return (
    <LtiDynamicRegistrationPage openidConfiguration={openid_configuration} registrationToken={registration_token} />
  )
}
